(function () {
  const iframe = document.querySelector('#modalIframe');
  const modalTitle = document.querySelector('#modalTitle');
  const modalDesignation = document.querySelector('#modalDesignation');
  const modalDesc = document.querySelector('#modalDesc');

  const modalImage = document.querySelector('#modalImage');

  const vcContainer = document.querySelectorAll('.video-modal-container');
  const dismissModal = document.querySelector('[data-dismiss-modal]');
  vcContainer.forEach((vc) => {
    if (vc.querySelector('[data-video-button]')) {
      vc.querySelector('[data-video-button]').addEventListener(
        'click',
        function () {
          if (modalTitle) {
            modalTitle.innerHTML = this.dataset.name;
          }
          if (modalDesignation) {
            modalDesignation.innerHTML = this.dataset.designation;
          }

          if (modalDesc) {
            modalDesc.innerHTML = this.dataset.description;
          }

          if (modalImage) {
            modalImage.src = this.dataset.img;
          }
        }
      );
    }
  });
  if (dismissModal) {
    dismissModal.onclick = (e) => {
      if (iframe) {
        iframe.src = '';
      }
    };
  }

  const modalTitleLight = document.querySelector('#modalTitleLight');
  const modalDesignationLight = document.querySelector(
    '#modalDesignationLight'
  );
  const modalDescLight = document.querySelector('#modalDescLight');

  const modalImageLight = document.querySelector('#modalImageLight');

  const vcContainerLight = document.querySelectorAll('.video-modal-container');
  const dismissModalLight = document.querySelector('[data-dismiss-modal]');
  vcContainerLight.forEach((vc) => {
    if (vc.querySelector('[data-video-button]')) {
      vc.querySelector('[data-video-button]').addEventListener(
        'click',
        function () {
          if (modalTitleLight) {
            modalTitleLight.innerHTML = this.dataset.name;
          }
          if (modalDesignationLight) {
            modalDesignationLight.innerHTML = this.dataset.designation;
          }

          if (modalDescLight) {
            modalDescLight.innerHTML = this.dataset.description;
          }

          if (modalImageLight) {
            modalImageLight.src = this.dataset.img;
          }
        }
      );
    }
  });

  if (dismissModalLight) {
    dismissModalLight.onclick = (e) => {
      if (iframe) {
        iframe.src = '';
      }
    };
  }

  const solutionModalVideo = document.querySelector('#solutionModalVideo');

  const solutionVcContainer = document.querySelectorAll(
    '.video-modal-container'
  );
  const solutionDismissModal = document.querySelector('[data-dismiss-modal]');
  solutionVcContainer.forEach((vc) => {
    if (vc.querySelector('[data-video-button]')) {
      vc.querySelector('[data-video-button]').addEventListener(
        'click',
        function () {
          if (solutionModalVideo) {
            solutionModalVideo.src = this.dataset.img;
          }
        }
      );
    }
  });

  if (solutionDismissModal) {
    solutionDismissModal.onclick = (e) => {
      if (iframe) {
        iframe.src = '';
      }
    };
  }

  const finlabsModalTitle = document.querySelector('#finlabsModalTitle');
  const finlabsModalDesignation = document.querySelector(
    '#finlabsModalDesignation'
  );
  const finlabsModalDesc = document.querySelector('#finlabsModalDesc');

  const finlabsModalImage = document.querySelector('#finlabsModalImage');

  const finlabsVcContainer = document.querySelectorAll(
    '.video-modal-container'
  );
  const finlabsDismissModal = document.querySelector('[data-dismiss-modal]');
  finlabsVcContainer.forEach((vc) => {
    if (vc.querySelector('[data-video-button]')) {
      vc.querySelector('[data-video-button]').addEventListener(
        'click',
        function () {
          if (finlabsModalTitle) {
            finlabsModalTitle.innerHTML = this.dataset.name;
          }
          if (finlabsModalDesignation) {
            finlabsModalDesignation.innerHTML = this.dataset.designation;
          }

          if (finlabsModalDesc) {
            finlabsModalDesc.innerHTML = this.dataset.description;
          }

          if (finlabsModalImage) {
            finlabsModalImage.style.backgroundImage = this.dataset.img;
          }
        }
      );
    }
  });

  if (finlabsDismissModal) {
    finlabsDismissModal.onclick = (e) => {
      if (iframe) {
        iframe.src = '';
      }
    };
  }
})();
